﻿import React, { useContext } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import Content_Container from '@Elements/Content_Container';
import { P } from '@Elements/Fonts';
import { Start_Button, Plus_Button } from '@Elements/Buttons';

import {
    Featured_Project,
    Projects_List_Item_Props
} from '@Util/Types';

export default function UsualProjects_Module(): JSX.Element {
    const [t] = useTranslation();
    const { featured_projects }: context_type = useContext(Context);

    return (
        <section className="Module Team_Module">
            <header className="Module_Header">
                <h2 className="Headline2">{t('Text.UsualProjects')}</h2>
            </header>
            <Content_Container>
                {
                    featured_projects?.length > 0 &&
                    <ul className="Module_Project_List">
                        {featured_projects?.map((project: Featured_Project, index: number): JSX.Element => (
                            <Projects_List_Item
                                key={project.projectId.toString()}
                                project={project}
                                index={index}
                                show_color={true}
                                show_customer_name={true}
                            />
                        ))}
                    </ul>
                }
            </Content_Container>
        </section>
    );
}

export const Projects_List_Item: React.FC<Projects_List_Item_Props> = React.memo((props) => {
    const [t] = useTranslation();
    const {
        current_project,
        create_default_entry
    }: context_type = useContext(Context);

    return (
        <li className="Module_Project_List_Item">
            <P>
                {
                    props.show_color &&
                    <span
                        className="Customer_Color"
                        style={{ backgroundColor: `rgb(${props.project.customerColor})` }}
                        aria-label="hidden"
                    ></span>
                }
                {
                    props.show_customer_name &&
                    <>
                        {
                            props.project.customerName
                        }
                        <span aria-label="hidden">-</span>
                    </>
                }
                <span>{props.project.projectName}</span>
            </P>
            <Plus_Button
                onClick={() => create_default_entry(props.project.projectId)}
                aria_name={t('Aria.AddDefaultTimeEntry')}
            />
            {
                current_project?.projectId !== props.project?.projectId &&
                <Start_Button
                    start_time_id={props.project.projectId}
                    project_name={props.project.projectName}
                />
            }
        </li>
    );
});